/**
 * Team Scoring Component
 *
 * This code exports a React component called TeamScore that displays the total score of a 
 * team in a scavenger hunt game. The component receives props such as team_id, hunt_duration, 
 * and enable_timer. It uses these props to calculate the team's score based on their base points, 
 * bonus points, checklist points, mystery message points, emergency message points, and time deduction. 
 * The component also has methods to handle refreshing the score and initializing the state. 
 * It uses the API utility to make HTTP requests to the server. 
 */

import React from 'react'
import PropTypes from 'prop-types'
import Alert from 'react-bootstrap/Alert'
import API from '../../utils/api'
import { getTeamTimeDeduction } from '../../utils/team-timer'
import BonusPoints from './bonus-points'

export default class TeamScore extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: ``,
      description: ``,
      data: [],
      initialized: false,
      alertShow: false,
    }
    this.handleRefresh = this.handleRefresh.bind(this)
    this.initialize = this.initialize.bind(this)
    this.timeDeduction = this.timeDeduction.bind(this)
  }

  componentDidMount() {
    this.setState({ data: this.props.host_scores })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.host_scores != prevProps.host_scores) {
      this.setState({
        data: this.props.host_scores,
      })
    }
  }

  initialize() {
    if (!this.state.initialized && this.state.data != this.props.host_scores) {
      this.setState({
        initialized: true,
        data: this.props.host_scores,
      })
    }
  }

  handleRefresh() {
    API.get(`/host/scoring/${this.props.team_id}/`, {
      headers: {
        Authorization: `JWT ${localStorage.getItem(`token`)}`,
      },
    })
      .then(res => {
        let json = res.data
        this.setState({
          data: json,
          //alertShow: true,
        })
        console.log(json)
        this.props.handle_refresh()
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  bonusPoints() {
    let score = 0
    this.state.data.map(item => (score += item.value))
    return score
  }

  basePoints() {
    const { team } = this.props
    let score = team.score ? team.score : 0
    if (team.secondary_answers !== null) {
      for (var id in team.secondary_answers) {
        if (team.secondary_answers[id].points) {
          score += team.secondary_answers[id].points
        }
      }
    }
    return score
  }

  checklistPoints() {
    let score = 0
    const { team } = this.props
    if (team.checklist_answers !== null) {
      for (var id in team.checklist_answers) {
        if (team.checklist_answers[id].points) {
          score += team.checklist_answers[id].points
        }
      }
    }
    return score
  }

  mysteryMessagePoints() {
    let score = 0
    const { team } = this.props
    if (team.mystery_message_answers !== null && team.mystery_message_answers.points !== undefined) {
      score += team.mystery_message_answers.points
    }
    return score
  }

  emergencyMessagePoints() {
    let score = 0
    const { team } = this.props
    if (
      team.emergency_message_answers !== undefined &&
      team.emergency_message_answers !== null &&
      team.emergency_message_answers.points !== undefined
    ) {
      score += team.emergency_message_answers.points
    }
    return score
  }

  timeDeduction() {
    const { team, hunt_duration, enable_timer } = this.props
    return getTeamTimeDeduction(team, hunt_duration, enable_timer)
  }

  render() {
    const basePoints = this.basePoints()
    const bonusPoints = this.bonusPoints()
    const checklistPoints = this.checklistPoints()
    const mysteryMessagePoints = this.mysteryMessagePoints()
    const emergencyMessagePoints = this.emergencyMessagePoints()
    const timeDeduction = this.timeDeduction()
    const score =
      basePoints + checklistPoints + mysteryMessagePoints + emergencyMessagePoints + bonusPoints - timeDeduction
    return (
      <>
        <div className={`card-footer`}>
          <div className={`row`}>
            <div className={`col-8`}>
              <span className={`d-block total-points`}>Total Points</span>
              <small>
                ({basePoints} base + {checklistPoints !== 0 && <>{checklistPoints} checklist +</>}
                {` `}
                {mysteryMessagePoints !== 0 && <>{mysteryMessagePoints} mystery message +</>}{` `}
                {emergencyMessagePoints !== 0 && <>{emergencyMessagePoints} emergency message +</>} {bonusPoints} bonus
                {` `}
                {timeDeduction !== 0 && <>- {timeDeduction} time deduction </>})
              </small>
            </div>
            <div className={`col-4 text-lowercase text-right`}>
              <p className={`title h6 mb-0`}>{score} pts</p>
            </div>
          </div>
        </div>
      </>
    )
  }
}

TeamScore.propTypes = {
  team_id: PropTypes.number,
  hunt_duration: PropTypes.number,
  enable_timer: PropTypes.bool,
}

TeamScore.defaultProps = {
  team_id: ``,
  hunt_duration: 2,
  enable_timer: false,
}
